import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackWithdrawalCancel = (hoursDiff: number) =>
  trackEvent('withdrawal_cancel', { hoursDiff })
